import { render } from "./ResultsPage.vue?vue&type=template&id=323881f5&scoped=true"
import script from "./ResultsPage.vue?vue&type=script&lang=js"
export * from "./ResultsPage.vue?vue&type=script&lang=js"

import "./ResultsPage.vue?vue&type=style&index=0&id=323881f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323881f5"]])

export default __exports__